import { render, staticRenderFns } from "./SwiperSlider.vue?vue&type=template&id=30a17b67"
import script from "./SwiperSlider.vue?vue&type=script&lang=js"
export * from "./SwiperSlider.vue?vue&type=script&lang=js"
import style0 from "./SwiperSlider.vue?vue&type=style&index=0&id=30a17b67&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports